import { getOfflineMutations, deleteOfflineMutation } from './offlineStorage';
import { toast } from 'sonner';
import { offlineMutationMetadata } from './offlineMutationPolicy';

export const SyncManager = {
  replayMutations: async () => {
    const mutations = await getOfflineMutations();
    if (mutations.length === 0) return;

    toast.loading(`Removing ${mutations.length} unsafe legacy offline changes...`, { id: 'sync-toast' });

    let removedCount = 0;
    let failCount = 0;

    // Sort by timestamp to replay in order
    mutations.sort((a, b) => a.timestamp - b.timestamp);

    for (const mutation of mutations) {
      try {
        if ((mutation as any).id) {
          await deleteOfflineMutation((mutation as any).id);
        }
        removedCount++;
      } catch (error) {
        console.error('Failed to remove unsafe legacy offline mutation:', offlineMutationMetadata(mutation as any), error);
        failCount++;
      }
    }

    if (failCount === 0) {
        toast.error(`${removedCount} legacy offline changes were not replayed because their identity could not be verified.`, { id: 'sync-toast' });
    } else {
        toast.error(`Removed ${removedCount} unsafe legacy offline changes. ${failCount} could not be removed.`, { id: 'sync-toast' });
    }
  }
};
